import { useTranslation } from '@framework/i18n';
import { getCurrentLanguage } from '../utils';

export function useCurrentLocale() {
  const { i18n } = useTranslation();
  return getCurrentLanguage(i18n);
}
